(function() {
    'use strict';
    angular
        .module('nasracApp')
        .factory('NasracAdminUserAccount', NasracAdminUserAccount);

    NasracAdminUserAccount.$inject = ['$resource', 'DateUtils'];

    function NasracAdminUserAccount ($resource, DateUtils) {
        var resourceUrl =  'api/nasrac-admin-user-accounts/:id';
        var xlsxContentType = 'application/octet-stream';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastLoginTime = DateUtils.convertDateTimeFromServer(data.lastLoginTime);
                        data.lastActivityTime = DateUtils.convertDateTimeFromServer(data.lastActivityTime);
                        data.lastPasswordChangeTime = DateUtils.convertDateTimeFromServer(data.lastPasswordChangeTime);
                        data.lastLockOutTime = DateUtils.convertDateTimeFromServer(data.lastLockOutTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'download' : {
                method : 'GET',
                url : 'api/nasrac-admin-user-accounts/download',
                headers: {
                    accept: xlsxContentType
                },
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], {type: xlsxContentType})
                    };
                }
            },
            'get_security_roles': { method: 'GET', url: 'api/nasrac-admin-user-accounts/security-roles', isArray: true}
        });
    }
})();
